export default "__VITE_ASSET__fawIm8wy__"